import React, {Component, ErrorInfo} from "react";

import Alert from "./Alert";

type Props = {
    children: any
}

type State = {
    error: object | null
}

class ErrorBoundary extends Component<Props, State>{
    constructor(props: Props) {
        super(props);

        this.state = {
            error: null,
        };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        // Catch errors in any components below and re-render with error message
        // console.log(errorInfo);
        this.setState({
            error,
        });
    }

    render() {
        if (this.state.error) {
            return (
                <Alert type="warning" className="error-boundary" isOpen={true}>
                    <strong>Something went wrong.</strong>{" "}
                    Please refresh the page and try again.
                </Alert>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
